import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Helmet from 'react-helmet';
import forEach from 'lodash/forEach';

import InfiniteScrollTrigger from './infiniteScrollTrigger';

import History from './history';

import {
	TIMELINE_FETCH_NEXT,
	TIMELINE_FETCH_PREV,
} from '../constants/actions';

export default class InfiniteScroll extends Component {
	static propTypes = {
		prev: PropTypes.string,
		next: PropTypes.string,
		fetch: PropTypes.func,
		browser: PropTypes.object.isRequired,
		pageUrl: PropTypes.string,
		initPage: PropTypes.number,
		page: PropTypes.number,
		contentHeight: PropTypes.number.isRequired,
		isFetching: PropTypes.bool,
		disableManualTrigger: PropTypes.bool,
	};

	static defaultProps = {
		prev: '',
		next: '',
		browser: {},
		hasPushState: false,
		pageUrl: '',
		page: 1,
		initPage: 1,
		isFetching: false,
		disableManualTrigger: false,
		fetch: (url, direction) => {},
	};

	constructor(props) {
		super();
		this.direction = TIMELINE_FETCH_NEXT;
		this.contentLength = 0;
		this.scrollY = 0;

		this.contentHeight = 0;
		this.contentTop = 0;
		this.contentHeight = 0;

		// console.log('initPage: ' + props.pageInit);

		this.pageBounds = {
			lower: props.initPage || 1,
			upper: props.initPage || 1,
		};

		this.state = {
			page: props.page,
			contentIteration: 0,
		};
	}

	componentDidMount() {
		// this.scrollHandler = (event) => {
		// 	//this.props.contentTop + this.props.contentHeight
		// 	if (!this.props.contentHeight || event.deltaY === 0) {
		// 		return;
		// 	}
		//
		// 	let percentageScrolled = (1 / this.props.contentHeight) * (event.scrollY - this.props.contentTop);
		// 	let boundedPages = 1 + (this.pageBounds.upper - this.pageBounds.lower);
		// 	let pageNum = ((this.pageBounds.lower - 1) + this.props.page) || 0;
		// 	//console.log(this.pageBounds);
		//
		//
		// 	if (this.props.page && pageNum && pageNum !== this.prevPageNum && this.props.hasPushState) {
		// 		//console.log(`${this.props.pageUrl}page/${pageNum}/`);
		// 		window.history.state && History.replaceState(window.history.state, `${this.props.pageUrl}page/${pageNum}/`);
		// 	} else if(!this.props.page || !pageNum && pageNum !== this.prevPageNum) {
		// 		window.history.state && History.replaceState(window.history.state, this.props.pageUrl);
		// 	}
		//
		// 	this.prevPageNum = pageNum;
		//
		// };
		//
		// this.props.browser.scroll.register(this.scrollHandler);
	}

	componentWillUnmount() {
		// this.props.browser.scroll.deregister(this.scrollHandler);
	}

	componentWillUpdate(nextProps, nextState) {
		//this.updateDimensions(nextProps);
	}

	componentWillReceiveProps(nProps) {
		if (this.props.initPage !== nProps.initPage) {
			this.pageBounds = {
				lower: nProps.initPage || 1,
				upper: nProps.initPage || 1,
			};
		}
	}

	componentDidUpdate(prevProps, prevState) {
		let currentContentHeight = this.props.contentHeight;
		//console.log(`${this.direction} === TIMELINE_FETCH_PREV && ${this.contentHeight} < ${currentContentHeight}`);
		if (this.direction === TIMELINE_FETCH_PREV && this.contentHeight < currentContentHeight) {
			let scrollY = window.scrollY;

			scrollY = scrollY + (currentContentHeight - this.contentHeight);

			window.scrollTo(0, scrollY);
		}

		this.contentHeight = currentContentHeight;

		if (prevProps.browser.window.width !== this.props.browser.window.width) {
			if (document.querySelectorAll('.timeline__element').length) {
				forEach(document.querySelectorAll('.timeline__element'), function(el, i){
					el.classList.add('active');
				});
			}
		}

		//this.scrollHandler({ deltaY: 1, scrollY: window.scrollY });

		// if (this.props.hasPushState) {
		// 	this.updatePushState();
		// } else {
		// 	if (prevProps.hasPushState !== this.props.hasPushState && this.props.pageUrl) {
		// 		// reset url
		// 		this.replaceState(this.props.pageUrl);
		// 	}
		// }
	}

	render() {
		//console.log(`prev: ${(!!this.props.prev).toString()} - next: ${(!!this.props.next).toString()}`);
		//console.log('InfiniteScroll - render');
		//console.log(History);

		//this.props.browser.scroll.registerScrollEvents();

		return (
			<div className='infintescroll'>
				{	this.props.prev &&
					<InfiniteScrollTrigger
						key='prev'
						browser={this.props.browser}
						contentUpdate={this.props.update}
						contentTrigger={this.props.contentTop}
						direction={TIMELINE_FETCH_PREV}
						callback={this.fetchPrev.bind(this)}
					/>
				}

				{ this.props.children }

				{	this.props.next &&
					<InfiniteScrollTrigger
						key='next'
						browser={this.props.browser}
						contentUpdate={this.props.update}
						contentTrigger={this.props.contentTop + this.props.contentHeight}
						direction={TIMELINE_FETCH_NEXT}
						callback={this.fetchNext.bind(this)}
						manualTrigger={((this.pageBounds.lower === 1 && this.pageBounds.upper === 1) && !this.props.disableManualTrigger)}
						triggerElement={(this.props.triggerElement || false)}
					/>
				}
			</div>
		);
	}

	// updatePushState() {
	// 	//console.log('updatePushState()');
	// 	let pageNum = ((this.pageBounds.lower - 1) + this.props.page) || 0;
	//
	// 	//console.log(this.pageBounds);
	//
	// 	if (pageNum && pageNum !== this.prevPageNum) {
	// 		//console.log(`${this.props.pageUrl}page/${pageNum}/`);
	// 		//console.log(`${this.pageBounds.lower} <> ${this.pageBounds.upper} ==> ${(this.pageBounds.lower - 1) + this.props.page} (${this.props.page})`);
	//
	// 		this.prevPageNum = pageNum;
	//
	// 		if (window.location.pathname) {
	//
	// 		}
	// 		this.replaceState(`${this.props.pageUrl}page/${pageNum}/`);
	// 	} else if (!this.props.page || !pageNum && pageNum !== this.prevPageNum) {
	// 		this.prevPageNum = pageNum;
	// 		this.replaceState(this.props.pageUrl);
	// 	}
	// }
	//
	// replaceState(path) {
	// 	if (
	// 		!!(window.history && window.history.replaceState) &&
	// 		path !== window.location.pathname
	// 	) {
	// 		window.history.replaceState(window.history.state || {}, window.document.title, path);
	// 	}
	// }

	fetchPrev() {
		//console.log(`isFetching: ${this.props.isFetching}`);
		if (!this.props.isFetching) {
			this.props.fetch(this.props.prev, TIMELINE_FETCH_PREV);
			this.direction = TIMELINE_FETCH_PREV;
			if (this.pageBounds.lower > 1) {
				this.pageBounds.lower--;
			}
		}
	}

	fetchNext() {
		//console.log(`isFetching: ${this.props.isFetching}`);
		if (!this.props.isFetching) {
			this.props.fetch(this.props.next, TIMELINE_FETCH_NEXT);
			this.direction = TIMELINE_FETCH_NEXT;
			this.pageBounds.upper++;
		}
	}

	nextPage() {
		this.setState({
			page: this.state.page++,
		});
	}

	prevPage() {
		this.setState({
			page: this.state.page--,
		});
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/utils/infiniteScroll.js
 **/